<template>
    <div>
        <card-header title="Applicants" icon="fa-users"></card-header>

        <card-toolbar>
            <button @click="exportApplicants()"><i class="far fa-file-excel"></i>Export</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <subheader-list-item title="Applicants" icon="fa-users" />

                <applicant-tile
                    :applicant="applicant"
                    :card="card"
                    v-for="applicant in applicants"
                    @click="$openCard('application-applicant', {applicantId: applicant.id, applicationId: props.applicationId, applicantType: applicant.type}, card)"
                    :active="(child && child.definition.component === 'application-applicant' && applicant.id === parseInt(child.props.applicantId))"
                />
            </card-list>
        </card-body>

        <card-footer>
            <strong>{{ applicants.length }}</strong> Total Applicants
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import CardList from "@/TIER/components/CardList";
    import CardSubheader from "@/TIER/components/CardSubheader";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import CardFooter from "@/TIER/components/CardFooter";


    import {client as http, apiUrl} from "@/http_client";
    import ConferenceTile from "../../../components/tiles/ConferenceTile";
    import RegistrationTile from "../../../components/tiles/RegistrationTile";
    import CardToolbar from "../../../TIER/components/CardToolbar.vue";
    import ApplicantTile from "../../../components/tiles/ApplicantTile.vue";

    import async from "async";

    export default {
        props: ['card', 'child', 'props'],
        components: {ApplicantTile, CardToolbar, RegistrationTile, ConferenceTile, CardFooter, CardHeader, CardBody, SearchListItem, CardList, CardSubheader, SubheaderListItem},
        data() {
            return {
                applicants: [],
                type: '',
                paging: {
                    total: 0,
                    start: 0,
                    count: 0
                },
                apiUrl: apiUrl,
            };
        },
        methods: {
            searchRegistrations: function (query) {
                this.$openCard('registration-search', {query, confId: this.props.confId, type: this.props.type}, this.card);
            },
            loadApplicants: function (force) {
                http.get('/applicants/application/' + this.props.applicationId, {force}).then(response => {

                    if (response.data.conf_applications) {
                        for (let i = 0; i < response.data.conf_applications.length; i++) {
                            const confApplication = response.data.conf_applications[i];

                            for (let j = 0; j < confApplication.reg_applications.length; j++) {
                                const regApplication = confApplication.reg_applications[j];

                                this.applicants.push({
                                    type: 'conf',
                                    ...regApplication,
                                    conference: confApplication.conferences
                                });
                            }
                        }
                    }

                    if (response.data.course_applications) {
                        for (let i = 0; i < response.data.course_applications.length; i++) {
                            const courseApplication = response.data.course_applications[i];

                            for (let j = 0; j < courseApplication.enrollment_applications.length; j++) {
                                const regApplication = courseApplication.enrollment_applications[j];

                                this.applicants.push({
                                    type: 'course',
                                    ...regApplication,
                                    course: courseApplication.courses
                                });
                            }
                        }
                    }

                    // sort this.applicants array by users.last_name
                    this.applicants.sort((a, b) => {
                        if (a.users.last_name < b.users.last_name) return -1;
                        if (a.users.last_name > b.users.last_name) return 1;
                        return 0;
                    });

                    this.$emit('loading', false);
                });
            },
            exportApplicants: function () {
                this.$emit('loading', true);

                http.post(`${this.apiUrl}applications/csv-export`, {applicationId: parseInt(this.props.applicationId)})
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'applicants.csv');
                        document.body.appendChild(link);
                        link.click();
                        this.$emit('loading', false);
                    })
                    .catch(error => {
                        console.log(error);
                        this.$emit('loading', false);

                        if (error.response.status === 404) {
                            window.alert('No applicants to export');
                        } else {
                            window.alert('Error exporting applicants');
                        }
                    });
            },
            reload: function () {
                this.loadApplicants(true);
            }
        },
        mounted: function () {
            this.loadApplicants();
        }
    };
</script>
